import * as React from "react";
import {createRef, useEffect} from "react";
import Chart from 'chart.js/auto';

function LineChart(props) {
    const canvas = createRef();
    useEffect(() => {
        const chart = new Chart(canvas.current, {
            type: "line",
            data: {
                labels: props.labels,
                datasets: props.dataset
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                    }
                }
            },
        });
        return () => chart.destroy();
    }, [props.labels, props.dataset, canvas]);


    return (<canvas ref={canvas} />);
}

export default LineChart;